import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommand from './CategoryCommand';

class DocLinksGraphCommand extends CategoryCommand<void | Record<string, any>> {
  public isAvailable(context: ClientContext): boolean {
    const id = context.get('Id');
    if (id === undefined) {
      return false;
    }
    const selected = context.get('SelectedIds');
    return (
      context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE &&
      (!selected ||
        selected.length === 0 ||
        (selected.length === 1 && selected[0] === id))
    );
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.DOC_LINKS_GRAPH,
    };
  }

  public getIcon(): IconName {
    return 'doclinks-graph';
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.DOC_LINKS_GRAPH,
    };
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }

  public getName(): CommandName {
    return 'DocLinksGraph';
  }
}

export default DocLinksGraphCommand;
